import { useMemo } from "react";
import styled from "styled-components";
import { GOOGLE_MAPS_API_KEY } from "../../../constants/map";
import { useAsset } from "../../../hooks/useAsset";

type Props = {
  location: { lat: number; lng: number };
};

export const StoreMap: React.FC<Props> = ({ location }) => {
  const { baseDir } = useAsset();

  const mapUrl = useMemo(() => {
    const coordinates = location.lat + "," + location.lng;
    return `\
https://maps.googleapis.com/maps/api/staticmap\
?center=${coordinates}\
&zoom=${16}\
&size=1024x1024\
&markers=${coordinates}\
&key=${GOOGLE_MAPS_API_KEY}`;
  }, [location]);

  return (
    <StoreMapContainer>
      <GoogleMapContainer>
        <MapContainer
          id="googleMap"
          style={{ backgroundImage: `url('${mapUrl}')` }}
        ></MapContainer>
      </GoogleMapContainer>

      <MapIcon
        style={{
          backgroundImage:
            "url('" + baseDir + "/assets/images/icons/icon-pin2.png')",
        }}
      ></MapIcon>
    </StoreMapContainer>
  );
};

const StoreMapContainer = styled.div`
  position: relative;
  width: 100%;
  max-width: 980px;
  height: 100%;
  max-height: 340px;
  overflow: hidden;
  margin: 0 auto;
`;

const GoogleMapContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 340px;
`;

const MapContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-position: center center;
  background-size: cover;
`;

const MapIcon = styled.div`
  position: absolute;
  top: 25%;
  left: 45%;
  width: 70px;
  height: 90px;
  background-size: contain;
  background-position: center center;
`;
